/*
==========================================
Custom JS for Collaboration article
==========================================
*/

// スクロールイン
const scrollIn = () => {
  const fadeInImages = document.querySelectorAll(".c-content__inner > *");
  for (var i = 0; i < fadeInImages.length; i++) {
    var elemPos = fadeInImages[i].getBoundingClientRect().top,
        scroll = window.pageYOffset || document.documentElement.scrollTop,
        windowHeight = window.innerHeight;

    if (scroll > elemPos  + scroll - windowHeight + (windowHeight * 0.15)) {
      fadeInImages[i].classList.add("scroll-in");
    }
  }
}
window.addEventListener("load", scrollIn);
window.addEventListener("scroll", scrollIn);
